import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'zap-templates',
  `
    DELETE_ZAP_TEMPLATE
  `
);
